var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84657 10.541C11.6589 10.541 13.9385 8.29314 13.9385 5.52051C13.9385 2.74789 11.6599 0.500061 8.84657 0.500061C6.03322 0.500061 3.75462 2.74789 3.75462 5.52051C3.75462 8.29314 6.03322 10.541 8.84657 10.541ZM11.4986 12.633H6.19457C3.11851 12.633 0.572021 15.1432 0.572021 18.1762C0.572021 18.908 0.890591 19.5364 1.5267 19.85C2.48137 20.3728 4.60276 21.0001 8.84657 21.0001C13.0904 21.0001 15.2118 20.3728 16.1664 19.85C16.4561 19.6745 16.6957 19.4287 16.8628 19.1358C17.0298 18.8429 17.1187 18.5126 17.1211 18.1762C17.1211 15.0387 14.5757 12.633 11.4986 12.633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a44356fda342b342c48eadf6d0f33e9e.svg";
export { ForwardRef as ReactComponent };